import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { UserType } from 'src/types/user';

export interface TopBlockPropsType {
    data: UserType | null;
    idUser: string | undefined;
    newUser: boolean;
    disableEdit: boolean;
    handleSave: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        label: translate(props.newUser ? 'userDetail.action.create' : 'userDetail.action.save'),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: props.disableEdit,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
